module.exports = __webpack_public_path__ + "static/media/arrow-down-solid.8cace02c.svg";